import { gql } from '@apollo/client'

// Query simple para las bandejas de notificaciones (sin paginación)
export const GET_MY_NOTIFICATIONS = gql`
  query myNotifications(
    $first: Int
    $offset: Int
    $isRead: Boolean
    $notificationType: String
    $search: String
    $orderBy: [String]
  ) {
    allNotifications(
      first: $first
      offset: $offset
      isRead: $isRead
      notificationType: $notificationType
      search: $search
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          notificationType
          priority
          title
          message
          metadata
          actionUrl
          isRead
          readAt
          created
          createdBy {
            id
            firstName
            lastName
            email
          }
          policy {
            id
            policyName
          }
          lead {
            id
            name
          }
        }
      }
      totalCount
    }
  }
`

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql`
  query unreadNotificationsCount {
    unreadNotificationsCount
  }
`

export const GET_SIDEBAR_COUNTERS = gql`
  query sidebarCounters {
    sidebarCounters {
      unreadNotificationsCount
      openTicketsCount
      inboxUnreadCount
      policyChatUnreadCount
    }
  }
`

export const GET_UNREAD_NOTIFICATIONS_BY_TYPE = gql`
  query unreadNotificationsByType {
    unreadNotificationsByType {
      notificationType
      unreadCount
    }
  }
`

export const GET_NOTIFICATION_TYPES_WITH_DATA = gql`
  query notificationTypesWithData {
    notificationTypesWithData
  }
`

export const GET_NOTIFICATION_BY_ID = gql`
  query notification($id: Int!) {
    notification(id: $id) {
      id
      notificationType
      priority
      title
      message
      metadata
      actionUrl
      isRead
      readAt
      created
      createdBy {
        id
        firstName
        lastName
        email
      }
      policy {
        id
        policyName
      }
      lead {
        id
        name
      }
    }
  }
`
